import { useQuery } from "@tanstack/react-query";
import { Filters } from "../../../../../../../../../../models/shipeezi.table";
import { LoginSessionKeys } from "../../../../../../../../../../util/queries";
import LoginSessionService from "Services/login-sessions.service";

export const useLoginSessionsActions = (memberId?: number, companyId?: number) => {

  const getSessions = (
  page: number,
  pageSize: number,
  filters: Filters
) => {
  return useQuery({
    queryKey: LoginSessionKeys.getAll([memberId, companyId, page, pageSize, filters]),
    queryFn: async () => {
      const response = await LoginSessionService.getAll({
        userId: memberId,
        companyId,
        page,
        pageSize,
        ...filters,
      });

      if (response?.data && Array.isArray(response.data)) {
        return response.data;
      }

      return [];
    },
    enabled: !!memberId,
    refetchOnWindowFocus: false,
  });
};

const getSessionsCount = (filters: Filters) => {
  return useQuery({
    queryKey: LoginSessionKeys.count([filters]),
    queryFn: async () => {
      const response = await LoginSessionService.count({
        userId: memberId,
        companyId,
        ...filters,
      });

      if (response && response.data) return response.data;

      return 0;
    },
    enabled: !!memberId,
    refetchOnWindowFocus: false,
  });
};

  return {
    getSessions,
    getSessionsCount,
  };
};
